import { Box, type SxProps, type Theme } from "@mui/material";
import { gridDividerStyle, gridDividerSx } from "../utils";

/**
 * We use this divider to separate between weeks in the Master Schedule Grid
 */
export const GridDivider = ({ overflowHeight = true }: { overflowHeight?: boolean }) => {
	return (
		<Box sx={{ position: "relative", height: "100%", pointerEvents: "none", overflow: "visible" }}>
			<Box
				sx={
					[
						gridDividerSx,
						{ width: gridDividerStyle.width, height: overflowHeight ? gridDividerStyle.height : "100%", position: "absolute", top: 0 },
					] as SxProps<Theme>
				}
			/>
		</Box>
	);
};
